import ProductData from "./ProductData";
import apiSpaceDataSchema from "../../services/bimVisualizerApi/schema/productData/apiSpaceDataSchema";
import { ElementTypeEnum } from "../../elementTypeMappings";
import { UUID } from "../../utils/typeDefinitions";
import { getScaledVector2 } from '../../utils/scaler';

export default class SpaceData extends ProductData {

    apartmentId: UUID;
    
    constructor(mappingId: string | undefined, apartmentId: string) {
        super(ElementTypeEnum.Space, mappingId);
        this.apartmentId = apartmentId;
    }

    static fromJSON(json: any): ProductData {

        const parsed = apiSpaceDataSchema.parse(json);

        return new SpaceData(   parsed.mappingId ?? undefined, 
                                parsed.apartmentId);

    }
}